// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useUserAuth } from "../context/UserAuthContext";
// import { db } from '../config/fbConfig';
// import {
//   collection,
//   addDoc,
//   doc,
//   getDocs,
//   updateDoc,
//   query,
//   where,
//   Timestamp
// } from 'firebase/firestore';
// import Modal from 'react-modal';
// import Loader from "./Loader";
// import SuccessModal from './SuccessModal';
// import * as XLSX from 'xlsx';
// import Papa from 'papaparse';
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import Logo from '../images/hotel_logo.png';
// import { HOTEL_NAME } from "../Variables.js";

// Modal.setAppElement('#root');

// // Date formatters (same as your Rooms component)
// const dateFormatter = new Intl.DateTimeFormat('en-NG', {
//   day: '2-digit',
//   month: 'short',
//   year: 'numeric'
// });

// const formatDateTime = (date) => {
//   return date.toLocaleString('en-GB', {
//     day: '2-digit',
//     month: 'short',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true
//   }).replace(',', '');
// };

// const formatDateForFilename = (date) => {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const day = String(date.getDate()).padStart(2, '0');
//   return `${year}-${month}-${day}`;
// };

// const Guests = () => {
//   const { user, userData } = useUserAuth();
//   const [loading, setLoading] = useState(false);
//   const [update, setUpdate] = useState(false);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   const [guests, setGuests] = useState([]);
//   const [filteredGuests, setFilteredGuests] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');

//   const [newGuest, setNewGuest] = useState({
//     fullName: '',
//     email: '',
//     phone: '',
//     active: true
//   });

//   const [editingGuest, setEditingGuest] = useState(null);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
//   const [isBulkImportModalOpen, setIsBulkImportModalOpen] = useState(false);
//   const [currentGuest, setCurrentGuest] = useState(null);
//   const [isFetching, setIsFetching] = useState(true);
//   const [file, setFile] = useState(null);
//   const [fileType, setFileType] = useState('excel');

//   const guestsCollectionRef = collection(db, "guests");

//   useEffect(() => {
//     if (user && userData) {
//       fetchGuests();
//     }
//   }, [user, userData]);

//   useEffect(() => {
//     const filtered = guests.filter((guest) =>
//       guest.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       guest.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       guest.phone?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredGuests(filtered);
//   }, [searchTerm, guests]);

//   const fetchGuests = async () => {
//     if (!user?.uid) return;

//     setIsFetching(true);
//     try {
//       const snapshot = await getDocs(guestsCollectionRef);
//       const guestList = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setGuests(guestList);
//     } catch (err) {
//       console.error("Error fetching guests:", err);
//       setError("Failed to load guests");
//       setShowModal(true);
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   const checkDuplicate = async (email, phone, excludeId = null) => {
//     const qEmail = query(
//       guestsCollectionRef,
//       where("email", "==", email.trim().toLowerCase())
//     );
//     const qPhone = query(
//       guestsCollectionRef,
//       where("phone", "==", phone.trim())
//     );

//     const [emailSnap, phoneSnap] = await Promise.all([
//       getDocs(qEmail),
//       getDocs(qPhone)
//     ]);

//     let hasDuplicate = false;

//     emailSnap.forEach(doc => {
//       if (doc.id !== excludeId) hasDuplicate = true;
//     });

//     phoneSnap.forEach(doc => {
//       if (doc.id !== excludeId) hasDuplicate = true;
//     });

//     return hasDuplicate;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewGuest({ ...newGuest, [name]: value });
//   };

//   const validateGuest = (guest) => {
//     if (!guest.fullName?.trim()) return "Full name is required";
//     if (!guest.email?.trim()) return "Email is required";
//     if (!guest.phone?.trim()) return "Phone number is required";

//     // Basic email format check
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(guest.email)) {
//       return "Invalid email format";
//     }

//     return null;
//   };

//   const handleAddGuest = async () => {
//     const validationError = validateGuest(newGuest);
//     if (validationError) {
//       setError(validationError);
//       setShowModal(true);
//       return;
//     }

//     setUpdate(true);
//     try {
//       const hasDuplicate = await checkDuplicate(newGuest.email, newGuest.phone);
//       if (hasDuplicate) {
//         setError("A guest with this email or phone number already exists");
//         setShowModal(true);
//         return;
//       }

//       await addDoc(guestsCollectionRef, {
//         ...newGuest,
//         fullName: newGuest.fullName.trim(),
//         email: newGuest.email.trim().toLowerCase(),
//         phone: newGuest.phone.trim(),
//         userId: user?.uid,
//         createdAt: Timestamp.now()
//       });

//       setSuccessMessage("Guest added successfully");
//       fetchGuests();
//       resetForm();
//       setIsAddModalOpen(false);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to add guest");
//     } finally {
//       setUpdate(false);
//       setShowModal(true);
//     }
//   };

//   const handleUpdateGuest = async () => {
//     if (!editingGuest?.id) return;

//     const validationError = validateGuest(newGuest);
//     if (validationError) {
//       setError(validationError);
//       setShowModal(true);
//       return;
//     }

//     setUpdate(true);
//     try {
//       const hasDuplicate = await checkDuplicate(
//         newGuest.email,
//         newGuest.phone,
//         editingGuest.id
//       );

//       if (hasDuplicate) {
//         setError("Another guest is already using this email or phone number");
//         setShowModal(true);
//         return;
//       }

//       const guestDoc = doc(db, "guests", editingGuest.id);
//       await updateDoc(guestDoc, {
//         ...newGuest,
//         fullName: newGuest.fullName.trim(),
//         email: newGuest.email.trim().toLowerCase(),
//         phone: newGuest.phone.trim()
//       });

//       setSuccessMessage("Guest updated successfully");
//       fetchGuests();
//       resetForm();
//       setEditingGuest(null);
//       setIsEditModalOpen(false);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to update guest");
//     } finally {
//       setUpdate(false);
//       setShowModal(true);
//     }
//   };

//   const resetForm = () => {
//     setNewGuest({
//       fullName: '',
//       email: '',
//       phone: '',
//       active: true
//     });
//   };

//   const handleEdit = (guest) => {
//     setEditingGuest(guest);
//     setNewGuest({
//       fullName: guest.fullName || '',
//       email: guest.email || '',
//       phone: guest.phone || '',
//       active: guest.active ?? true
//     });
//     setIsEditModalOpen(true);
//   };

//   const confirmDeactivate = (guest) => {
//     setCurrentGuest(guest);
//     setIsDeactivateModalOpen(true);
//   };

//   const handleDeactivate = async () => {
//     if (!currentGuest?.id) return;
//     setUpdate(true);
//     try {
//       await updateDoc(doc(db, "guests", currentGuest.id), { active: false });
//       setSuccessMessage("Guest deactivated successfully");
//       fetchGuests();
//     } catch (err) {
//       setError("Failed to deactivate guest");
//     } finally {
//       setUpdate(false);
//       setIsDeactivateModalOpen(false);
//       setShowModal(true);
//     }
//   };

//   const generateGuestsPDF = () => {
//     if (guests.length === 0) {
//       setError("No guests to export");
//       setShowModal(true);
//       return;
//     }

//     const doc = new jsPDF();
//     const fullName = userData?.firstName && userData?.lastName
//       ? `${userData.firstName} ${userData.lastName}`
//       : user?.displayName || "Staff";

//     let y = 10;
//     doc.addImage(Logo, "PNG", 14, y, 15, 15);
//     doc.setFontSize(16); doc.setFont("helvetica", "bold"); doc.text(HOTEL_NAME, 35, y + 5);
//     doc.setFontSize(14); doc.text("Guest List Report", 35, y + 13);
//     doc.setFontSize(10);
//     doc.text(`Generated by: ${fullName}`, 35, y + 18);
//     doc.text(`Generated on: ${formatDateTime(new Date())}`, 35, y + 23);
//     y += 28;

//     const tableData = guests.map((g, i) => [
//       (i + 1).toString(),
//       g.fullName,
//       g.email,
//       g.phone,
//       g.active ? 'Active' : 'Inactive',
//       g.createdAt ? dateFormatter.format(g.createdAt.toDate()) : '—'
//     ]);

//     autoTable(doc, {
//       startY: y,
//       head: [['S/N', 'Full Name', 'Email', 'Phone', 'Status', 'Added On']],
//       body: tableData,
//       theme: 'striped',
//       margin: { left: 4, right: 10 },
//       styles: { fontSize: 9, textColor: 0 },
//       headStyles: { fillColor: [41, 128, 185], textColor: 255 },
//       columnStyles: {
//         0: { cellWidth: 12 },
//         1: { cellWidth: 50 },
//         2: { cellWidth: 60 },
//         3: { cellWidth: 35 },
//         4: { cellWidth: 20 },
//         5: { cellWidth: 28 }
//       }
//     });

//     doc.save(`guests_${formatDateForFilename(new Date())}.pdf`);
//   };

//   const handleFileChange = (e) => setFile(e.target.files[0]);
//   const handleFileTypeChange = (e) => setFileType(e.target.value);

//   const processBulkImport = async () => {
//     if (!file) {
//       setError("Please select a file");
//       setShowModal(true);
//       return;
//     }
//     setUpdate(true);
//     try {
//       let dataArray = [];
//       if (fileType === 'excel') {
//         const buffer = await file.arrayBuffer();
//         const workbook = XLSX.read(buffer);
//         const sheet = workbook.Sheets[workbook.SheetNames[0]];
//         dataArray = XLSX.utils.sheet_to_json(sheet);
//       } else {
//         const text = await file.text();
//         const result = Papa.parse(text, { header: true, skipEmptyLines: true });
//         dataArray = result.data;
//       }

//       if (dataArray.length === 0) throw new Error("No data found");

//       let successCount = 0;
//       let errorCount = 0;

//       for (let item of dataArray) {
//         try {
//           const guest = {
//             fullName: item.fullName || '',
//             email: item.email || '',
//             phone: item.phone || '',
//             active: item.active !== undefined ? Boolean(item.active) : true
//           };

//           const validationError = validateGuest(guest);
//           if (validationError) { errorCount++; continue; }

//           const hasDuplicate = await checkDuplicate(guest.email, guest.phone);
//           if (hasDuplicate) { errorCount++; continue; }

//           await addDoc(guestsCollectionRef, {
//             ...guest,
//             fullName: guest.fullName.trim(),
//             email: guest.email.trim().toLowerCase(),
//             phone: guest.phone.trim(),
//             userId: user?.uid,
//             createdAt: Timestamp.now()
//           });
//           successCount++;
//         } catch (err) {
//           errorCount++;
//         }
//       }

//       setSuccessMessage(`Imported ${successCount} guests (${errorCount} failed)`);
//       fetchGuests();
//     } catch (err) {
//       setError(`Import failed: ${err.message}`);
//     } finally {
//       setUpdate(false);
//       setFile(null);
//       setIsBulkImportModalOpen(false);
//       setShowModal(true);
//     }
//   };

//   const allowedRoles = ['Admin', 'Supreme', 'Cashier', 'Front Desk'];

//   if (!userData || !allowedRoles.includes(userData.status)) {
//     return <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>;
//   }

//   const displayContent = () => {
//     if (isFetching) return <p className="loading-text">Loading guests...</p>;

//     if (filteredGuests.length === 0) {
//       return searchTerm
//         ? <p className="loading-text">No guests match your search.</p>
//         : <p className="loading-text">No guests added yet. Click "Add Guest" to begin.</p>;
//     }

//     return filteredGuests.map((guest) => (
//       <div key={guest.id} className="class-item">
//         <div className="column gap-1">
//           <p>
//             <strong>{guest.fullName}</strong><br />
//             <span>Email: {guest.email}</span><br />
//             <span>Phone: {guest.phone}</span><br />
//             <span className={`size5 bold ${guest.active ? 'font-green' : 'font-gray'}`}>
//               {guest.active ? 'Active' : 'Inactive'}
//             </span>
//           </p>
//         </div>
//         <div className="row align-center justify-center gap-15">
//           <button className="list-btn" onClick={() => handleEdit(guest)}>
//             <i className="fas fa-edit"></i>
//           </button>
//           {guest.active && (
//             <button className="list-btn delete-btn" onClick={() => confirmDeactivate(guest)}>
//               <i className="fas fa-ban"></i>
//             </button>
//           )}
//         </div>
//       </div>
//     ));
//   };

//   return (
//     <>
//       {update && <Loader text={"Processing"} />}

//       <div className="top-elements row align-center space-between">
//         <Link to="/home" className="back-link">
//           <i className="fa-solid fa-arrow-left size3"></i>
//         </Link>
//         <h2 className="manage-page-heading caps size4 margin-top-cashflow1">Guests</h2>
//         <Link to="#" className="home-link" onClick={fetchGuests}>
//           <i className="fa-solid fa-rotate-right size4"></i>
//         </Link>
//       </div>

//       <div className="login-page-items login-page-items-cashflow column align-center scroll-fixed scroll-fixed4">
//         <div className="row justify-center align-center gap-15 add-buttons add-buttons1 margin-top-cashflow1">
//           <button className="login-button login-button-d caps" onClick={() => setIsAddModalOpen(true)}>
//             Add Guest
//           </button>
//           <button className="list-btn" onClick={generateGuestsPDF}>
//             <i className="fas fa-print"></i>
//           </button>
//           <button className="login-button login-button-d caps" onClick={() => setIsBulkImportModalOpen(true)}>
//             Bulk Import
//           </button>
//         </div>

//         <input
//           type="text"
//           className="input-field1"
//           placeholder="Search by name, email or phone..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />

//         <div className="scroll-fixed scroll-fixed1">
//           <div className="class-list class-list-d scrollable">
//             {displayContent()}
//           </div>
//         </div>
//       </div>

//       {showModal && (
//         <SuccessModal
//           icon={error ? "xmark" : "check"}
//           iconColor={error ? "red" : "green"}
//           message={error || successMessage}
//           onClose={() => { setError(""); setSuccessMessage(""); setShowModal(false); }}
//         />
//       )}

//       {/* Add Modal */}
//       <Modal isOpen={isAddModalOpen} onRequestClose={() => setIsAddModalOpen(false)} className="custom-modal" overlayClassName="custom-modal-overlay">
//         <h2>Add Guest</h2>
//         <form className="session-form">
//           <label className="input-label">Full Name</label>
//           <input
//             type="text"
//             name="fullName"
//             className="input-field"
//             placeholder="John Doe"
//             value={newGuest.fullName}
//             onChange={handleInputChange}
//             required
//           />

//           <label className="input-label">Email</label>
//           <input
//             type="email"
//             name="email"
//             className="input-field"
//             placeholder="john.doe@example.com"
//             value={newGuest.email}
//             onChange={handleInputChange}
//             required
//           />

//           <label className="input-label">Phone Number</label>
//           <input
//             type="tel"
//             name="phone"
//             className="input-field"
//             placeholder="08012345678"
//             value={newGuest.phone}
//             onChange={handleInputChange}
//             required
//           />

//           <div className="row align-center gap-1">
//             <button type="button" className="login-button" onClick={() => setIsAddModalOpen(false)}>
//               Cancel
//             </button>
//             <button type="button" className="login-button" onClick={handleAddGuest}>
//               Add Guest
//             </button>
//           </div>
//         </form>
//       </Modal>

//       {/* Edit Modal */}
//       <Modal isOpen={isEditModalOpen} onRequestClose={() => { setIsEditModalOpen(false); resetForm(); setEditingGuest(null); }} className="custom-modal" overlayClassName="custom-modal-overlay">
//         <h2>Edit Guest</h2>
//         <form className="session-form">
//           <label className="input-label">Full Name</label>
//           <input
//             type="text"
//             name="fullName"
//             className="input-field"
//             value={newGuest.fullName}
//             onChange={handleInputChange}
//             required
//           />

//           <label className="input-label">Email</label>
//           <input
//             type="email"
//             name="email"
//             className="input-field"
//             value={newGuest.email}
//             onChange={handleInputChange}
//             required
//           />

//           <label className="input-label">Phone Number</label>
//           <input
//             type="tel"
//             name="phone"
//             className="input-field"
//             value={newGuest.phone}
//             onChange={handleInputChange}
//             required
//           />

//           <label>
//             <input
//               type="checkbox"
//               className='gold-tick'
//               checked={newGuest.active}
//               onChange={(e) => setNewGuest({ ...newGuest, active: e.target.checked })}
//             />
//             Active
//           </label>

//           <div className="row align-center justify-center gap-1">
//             <button type="button" className="login-button" onClick={() => { setIsEditModalOpen(false); resetForm(); setEditingGuest(null); }}>
//               Cancel
//             </button>
//             <button type="button" className="login-button" onClick={handleUpdateGuest}>
//               Update Guest
//             </button>
//           </div>
//         </form>
//       </Modal>

//       {/* Deactivate Modal */}
//       <Modal isOpen={isDeactivateModalOpen} onRequestClose={() => setIsDeactivateModalOpen(false)} className="custom-modal" overlayClassName="custom-modal-overlay">
//         <h2>Deactivate Guest</h2>
//         {currentGuest && (
//           <div>
//             <p>Deactivate guest <strong>{currentGuest.fullName}</strong>?</p>
//             <p className="size6">(This will prevent selection in new bookings)</p>
//             <div className="row align-center gap-1">
//               <button className="login-button" onClick={() => setIsDeactivateModalOpen(false)}>Cancel</button>
//               <button className="login-button delete-btn" onClick={handleDeactivate}>Deactivate</button>
//             </div>
//           </div>
//         )}
//       </Modal>

//       {/* Bulk Import Modal */}
//       <Modal isOpen={isBulkImportModalOpen} onRequestClose={() => { setIsBulkImportModalOpen(false); setFile(null); }} className="custom-modal" overlayClassName="custom-modal-overlay">
//         <h2>Bulk Import Guests</h2>
//         <div className="modal-form">
//           <div style={{ marginBottom: '5px' }}>
//             <label><input type="radio" name="fileType" value="excel" checked={fileType === 'excel'} onChange={handleFileTypeChange} /> Excel</label>&nbsp;&nbsp;
//             <label><input type="radio" name="fileType" value="csv" checked={fileType === 'csv'} onChange={handleFileTypeChange} /> CSV</label>
//           </div>

//           <input type="file" accept={fileType === 'excel' ? '.xlsx,.xls' : '.csv'} onChange={handleFileChange} className="input-field1" />

//           <div className="row align-center justify-center gap-15">
//             <button className="login-button caps" onClick={() => { setIsBulkImportModalOpen(false); setFile(null); }}>Cancel</button>
//             <button className="login-button caps" onClick={processBulkImport} disabled={!file || update}>Import</button>
//           </div>

//           <div className="import-instructions">
//             <h4>Format Instructions:</h4>
//             <p><strong>REQUIRED:</strong> fullName, email, phone</p>
//           </div>
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default Guests;







import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from '../config/fbConfig';
import {
  collection,
  where,
  getDocs,
  addDoc,
  doc,
  updateDoc,
  query,
  onSnapshot,
  writeBatch,
  Timestamp
} from 'firebase/firestore';
import Modal from 'react-modal';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from '../images/hotel_logo.png';
import { HOTEL_NAME } from "../Variables.js";

Modal.setAppElement('#root');

// Date formatters
const dateFormatter = new Intl.DateTimeFormat('en-NG', {
  day: '2-digit',
  month: 'short',
  year: 'numeric'
});

const formatDateTime = (date) => {
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).replace(',', '');
};

const formatDateForFilename = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const Guests = () => {
  const { user, userData } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [guests, setGuests] = useState([]);
  const [filteredGuests, setFilteredGuests] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [newGuest, setNewGuest] = useState({
    fullName: '',
    email: '',
    phone: '',
    active: true
  });

  const [editingGuest, setEditingGuest] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [isBulkImportModalOpen, setIsBulkImportModalOpen] = useState(false);
  const [currentGuest, setCurrentGuest] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState('excel');

  const guestsCollectionRef = collection(db, "guests");

  // ==================== REAL-TIME LISTENER ====================
  useEffect(() => {
    if (!user?.uid || !userData) return;

    setIsFetching(true);

    const q = query(guestsCollectionRef);

    const unsubscribe = onSnapshot(q,
      (snapshot) => {
        const guestList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setGuests(guestList);
        setIsFetching(false);
      },
      (err) => {
        console.error("Error in guests listener:", err);
        setError("Failed to load guests");
        setShowModal(true);
        setIsFetching(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid, userData]);

  // Search filter
  useEffect(() => {
    const filtered = guests.filter((guest) =>
      guest.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      guest.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      guest.phone?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredGuests(filtered);
  }, [searchTerm, guests]);

  const checkDuplicate = async (email, phone, excludeId = null) => {
    if (!email && !phone) return false;

    const emailQuery = email ? query(guestsCollectionRef, where("email", "==", email.trim().toLowerCase())) : null;
    const phoneQuery = phone ? query(guestsCollectionRef, where("phone", "==", phone.trim())) : null;

    const [emailSnap, phoneSnap] = await Promise.all([
      emailQuery ? getDocs(emailQuery) : { docs: [] },
      phoneQuery ? getDocs(phoneQuery) : { docs: [] }
    ]);

    let hasDuplicate = false;

    emailSnap.docs.forEach(doc => {
      if (doc.id !== excludeId) hasDuplicate = true;
    });

    phoneSnap.docs.forEach(doc => {
      if (doc.id !== excludeId) hasDuplicate = true;
    });

    return hasDuplicate;
  };

  const validateGuest = (guest) => {
    if (!guest.fullName?.trim()) return "Full name is required";
    if (!guest.email?.trim()) return "Email is required";
    if (!guest.phone?.trim()) return "Phone number is required";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(guest.email)) {
      return "Invalid email format";
    }
    return null;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewGuest({ ...newGuest, [name]: value });
  };

  const resetForm = () => {
    setNewGuest({
      fullName: '',
      email: '',
      phone: '',
      active: true
    });
  };

  const handleAddGuest = async () => {
    const validationError = validateGuest(newGuest);
    if (validationError) {
      setError(validationError);
      setShowModal(true);
      return;
    }

    setUpdate(true);
    try {
      const hasDuplicate = await checkDuplicate(newGuest.email, newGuest.phone);
      if (hasDuplicate) {
        setError("A guest with this email or phone number already exists");
        setShowModal(true);
        return;
      }

      await addDoc(guestsCollectionRef, {
        ...newGuest,
        fullName: newGuest.fullName.trim(),
        email: newGuest.email.trim().toLowerCase(),
        phone: newGuest.phone.trim(),
        userId: user?.uid,
        createdAt: Timestamp.now()
      });

      setSuccessMessage("Guest added successfully");
      resetForm();
      setIsAddModalOpen(false);
    } catch (err) {
      console.error(err);
      setError("Failed to add guest");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleUpdateGuest = async () => {
    if (!editingGuest?.id) return;

    const validationError = validateGuest(newGuest);
    if (validationError) {
      setError(validationError);
      setShowModal(true);
      return;
    }

    setUpdate(true);
    try {
      const hasDuplicate = await checkDuplicate(
        newGuest.email,
        newGuest.phone,
        editingGuest.id
      );

      if (hasDuplicate) {
        setError("Another guest is already using this email or phone number");
        setShowModal(true);
        return;
      }

      const guestDoc = doc(db, "guests", editingGuest.id);
      await updateDoc(guestDoc, {
        ...newGuest,
        fullName: newGuest.fullName.trim(),
        email: newGuest.email.trim().toLowerCase(),
        phone: newGuest.phone.trim()
      });

      setSuccessMessage("Guest updated successfully");
      resetForm();
      setEditingGuest(null);
      setIsEditModalOpen(false);
    } catch (err) {
      console.error(err);
      setError("Failed to update guest");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleEdit = (guest) => {
    setEditingGuest(guest);
    setNewGuest({
      fullName: guest.fullName || '',
      email: guest.email || '',
      phone: guest.phone || '',
      active: guest.active ?? true
    });
    setIsEditModalOpen(true);
  };

  const confirmDeactivate = (guest) => {
    setCurrentGuest(guest);
    setIsDeactivateModalOpen(true);
  };

  const handleDeactivate = async () => {
    if (!currentGuest?.id) return;
    setUpdate(true);
    try {
      await updateDoc(doc(db, "guests", currentGuest.id), { active: false });
      setSuccessMessage("Guest deactivated successfully");
    } catch (err) {
      setError("Failed to deactivate guest");
    } finally {
      setUpdate(false);
      setIsDeactivateModalOpen(false);
      setShowModal(true);
    }
  };

  const generateGuestsPDF = () => {
    if (guests.length === 0) {
      setError("No guests to export");
      setShowModal(true);
      return;
    }

    const doc = new jsPDF();
    const fullName = userData?.firstName && userData?.lastName
      ? `${userData.firstName} ${userData.lastName}`
      : user?.displayName || "Staff";

    let y = 10;
    doc.addImage(Logo, "PNG", 14, y, 15, 15);
    doc.setFontSize(16); doc.setFont("helvetica", "bold"); doc.text(HOTEL_NAME, 35, y + 5);
    doc.setFontSize(14); doc.text("Guest List Report", 35, y + 13);
    doc.setFontSize(10);
    doc.text(`Generated by: ${fullName}`, 35, y + 18);
    doc.text(`Generated on: ${formatDateTime(new Date())}`, 35, y + 23);
    y += 28;

    const tableData = guests.map((g, i) => [
      (i + 1).toString(),
      g.fullName,
      g.email,
      g.phone,
      g.active ? 'Active' : 'Inactive',
      g.createdAt ? dateFormatter.format(g.createdAt.toDate()) : '—'
    ]);

    autoTable(doc, {
      startY: y,
      head: [['S/N', 'Full Name', 'Email', 'Phone', 'Status', 'Added On']],
      body: tableData,
      theme: 'striped',
      margin: { left: 4, right: 10 },
      styles: { fontSize: 9, textColor: 0 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: 50 },
        2: { cellWidth: 60 },
        3: { cellWidth: 35 },
        4: { cellWidth: 20 },
        5: { cellWidth: 28 }
      }
    });

    doc.save(`guests_${formatDateForFilename(new Date())}.pdf`);
  };

  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleFileTypeChange = (e) => setFileType(e.target.value);

  // ==================== OPTIMIZED BULK IMPORT WITH BATCH ====================
  const processBulkImport = async () => {
    if (!file) {
      setError("Please select a file");
      setShowModal(true);
      return;
    }

    setUpdate(true);
    try {
      let dataArray = [];
      if (fileType === 'excel') {
        const buffer = await file.arrayBuffer();
        const workbook = XLSX.read(buffer);
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        dataArray = XLSX.utils.sheet_to_json(sheet);
      } else {
        const text = await file.text();
        const result = Papa.parse(text, { header: true, skipEmptyLines: true });
        dataArray = result.data;
      }

      if (dataArray.length === 0) throw new Error("No data found");

      const batch = writeBatch(db);
      let successCount = 0;
      let errorCount = 0;

      for (let item of dataArray) {
        try {
          const guest = {
            fullName: item.fullName || '',
            email: item.email || '',
            phone: item.phone || '',
            active: item.active !== undefined ? Boolean(item.active) : true
          };

          const validationError = validateGuest(guest);
          if (validationError) {
            errorCount++;
            continue;
          }

          const hasDuplicate = await checkDuplicate(guest.email, guest.phone);
          if (hasDuplicate) {
            errorCount++;
            continue;
          }

          const newDocRef = doc(guestsCollectionRef);
          batch.set(newDocRef, {
            ...guest,
            fullName: guest.fullName.trim(),
            email: guest.email.trim().toLowerCase(),
            phone: guest.phone.trim(),
            userId: user?.uid,
            createdAt: Timestamp.now()
          });
          successCount++;
        } catch (err) {
          errorCount++;
        }
      }

      if (successCount > 0) {
        await batch.commit();
      }

      setSuccessMessage(`Imported ${successCount} guests (${errorCount} failed)`);
    } catch (err) {
      setError(`Import failed: ${err.message}`);
    } finally {
      setUpdate(false);
      setFile(null);
      setIsBulkImportModalOpen(false);
      setShowModal(true);
    }
  };

  const allowedRoles = ['Admin', 'Supreme', 'Cashier', 'Front Desk'];

  if (!userData || !allowedRoles.includes(userData.status)) {
    return <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>;
  }

  const displayContent = () => {
    if (isFetching) return <p className="loading-text">Loading guests...</p>;

    if (filteredGuests.length === 0) {
      return searchTerm
        ? <p className="loading-text">No guests match your search.</p>
        : <p className="loading-text">No guests added yet. Click "Add Guest" to begin.</p>;
    }

    return filteredGuests.map((guest) => (
      <div key={guest.id} className="class-item">
        <div className="column gap-1">
          <p>
            <strong>{guest.fullName}</strong><br />
            <span>Email: {guest.email}</span><br />
            <span>Phone: {guest.phone}</span><br />
            <span className={`size5 bold ${guest.active ? 'font-green' : 'font-gray'}`}>
              {guest.active ? 'Active' : 'Inactive'}
            </span>
          </p>
        </div>
        <div className="row align-center justify-center gap-15">
          <button className="list-btn" onClick={() => handleEdit(guest)}>
            <i className="fas fa-edit"></i>
          </button>
          {guest.active && (
            <button className="list-btn delete-btn" onClick={() => confirmDeactivate(guest)}>
              <i className="fas fa-ban"></i>
            </button>
          )}
        </div>
      </div>
    ));
  };

  return (
    <>
      {update && <Loader text={"Processing"} />}

      <div className="top-elements row align-center space-between">
        <Link to="/home" className="back-link">
          <i className="fa-solid fa-arrow-left size3"></i>
        </Link>
        <h2 className="manage-page-heading caps size4 margin-top-cashflow1">Guests</h2>
        <Link 
          to="#" 
          className="home-link" 
          onClick={() => alert("Data updates automatically in real-time!")}
        >
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>

      <div className="login-page-items login-page-items-cashflow column align-center scroll-fixed scroll-fixed4">
        <div className="row justify-center align-center gap-15 add-buttons add-buttons1 margin-top-cashflow1">
          <button className="login-button login-button-d caps" onClick={() => setIsAddModalOpen(true)}>
            Add Guest
          </button>
          <button className="list-btn" onClick={generateGuestsPDF}>
            <i className="fas fa-print"></i>
          </button>
          <button className="login-button login-button-d caps" onClick={() => setIsBulkImportModalOpen(true)}>
            Bulk Import
          </button>
        </div>

        <input
          type="text"
          className="input-field1"
          placeholder="Search by name, email or phone..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="scroll-fixed scroll-fixed1">
          <div className="class-list class-list-d scrollable">
            {displayContent()}
          </div>
        </div>
      </div>

      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => { setError(""); setSuccessMessage(""); setShowModal(false); }}
        />
      )}

      {/* Add Modal - unchanged */}
      <Modal isOpen={isAddModalOpen} onRequestClose={() => setIsAddModalOpen(false)} className="custom-modal" overlayClassName="custom-modal-overlay">
        <h2>Add Guest</h2>
        <form className="session-form">
          <label className="input-label">Full Name</label>
          <input
            type="text"
            name="fullName"
            className="input-field"
            placeholder="John Doe"
            value={newGuest.fullName}
            onChange={handleInputChange}
            required
          />

          <label className="input-label">Email</label>
          <input
            type="email"
            name="email"
            className="input-field"
            placeholder="john.doe@example.com"
            value={newGuest.email}
            onChange={handleInputChange}
            required
          />

          <label className="input-label">Phone Number</label>
          <input
            type="tel"
            name="phone"
            className="input-field"
            placeholder="08012345678"
            value={newGuest.phone}
            onChange={handleInputChange}
            required
          />

          <div className="row align-center gap-1">
            <button type="button" className="login-button" onClick={() => setIsAddModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="login-button" onClick={handleAddGuest}>
              Add Guest
            </button>
          </div>
        </form>
      </Modal>

      {/* Edit Modal - unchanged */}
      <Modal isOpen={isEditModalOpen} onRequestClose={() => { setIsEditModalOpen(false); resetForm(); setEditingGuest(null); }} className="custom-modal" overlayClassName="custom-modal-overlay">
        <h2>Edit Guest</h2>
        <form className="session-form">
          <label className="input-label">Full Name</label>
          <input
            type="text"
            name="fullName"
            className="input-field"
            value={newGuest.fullName}
            onChange={handleInputChange}
            required
          />

          <label className="input-label">Email</label>
          <input
            type="email"
            name="email"
            className="input-field"
            value={newGuest.email}
            onChange={handleInputChange}
            required
          />

          <label className="input-label">Phone Number</label>
          <input
            type="tel"
            name="phone"
            className="input-field"
            value={newGuest.phone}
            onChange={handleInputChange}
            required
          />

          <label>
            <input
              type="checkbox"
              className='gold-tick'
              checked={newGuest.active}
              onChange={(e) => setNewGuest({ ...newGuest, active: e.target.checked })}
            />
            Active
          </label>

          <div className="row align-center justify-center gap-1">
            <button type="button" className="login-button" onClick={() => { setIsEditModalOpen(false); resetForm(); setEditingGuest(null); }}>
              Cancel
            </button>
            <button type="button" className="login-button" onClick={handleUpdateGuest}>
              Update Guest
            </button>
          </div>
        </form>
      </Modal>

      {/* Deactivate Modal - unchanged */}
      <Modal isOpen={isDeactivateModalOpen} onRequestClose={() => setIsDeactivateModalOpen(false)} className="custom-modal" overlayClassName="custom-modal-overlay">
        <h2>Deactivate Guest</h2>
        {currentGuest && (
          <div>
            <p>Deactivate guest <strong>{currentGuest.fullName}</strong>?</p>
            <p className="size6">(This will prevent selection in new bookings)</p>
            <div className="row align-center gap-1">
              <button className="login-button" onClick={() => setIsDeactivateModalOpen(false)}>Cancel</button>
              <button className="login-button delete-btn" onClick={handleDeactivate}>Deactivate</button>
            </div>
          </div>
        )}
      </Modal>

      {/* Bulk Import Modal - unchanged */}
      <Modal isOpen={isBulkImportModalOpen} onRequestClose={() => { setIsBulkImportModalOpen(false); setFile(null); }} className="custom-modal" overlayClassName="custom-modal-overlay">
        <h2>Bulk Import Guests</h2>
        <div className="modal-form">
          <div style={{ marginBottom: '5px' }}>
            <label><input type="radio" name="fileType" value="excel" checked={fileType === 'excel'} onChange={handleFileTypeChange} /> Excel</label>&nbsp;&nbsp;
            <label><input type="radio" name="fileType" value="csv" checked={fileType === 'csv'} onChange={handleFileTypeChange} /> CSV</label>
          </div>

          <input type="file" accept={fileType === 'excel' ? '.xlsx,.xls' : '.csv'} onChange={handleFileChange} className="input-field1" />

          <div className="row align-center justify-center gap-15">
            <button className="login-button caps" onClick={() => { setIsBulkImportModalOpen(false); setFile(null); }}>Cancel</button>
            <button className="login-button caps" onClick={processBulkImport} disabled={!file || update}>Import</button>
          </div>

          <div className="import-instructions">
            <h4>Format Instructions:</h4>
            <p><strong>REQUIRED:</strong> fullName, email, phone</p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Guests;